import { useTranslation } from 'next-i18next';
import React, { FC, useCallback } from 'react';

import DeleteSettlementAction from '@/modules/Settlements/components/Details/shared/Header/ActionsButtons/DeleteSettlementAction';
import IssueSettlementModal from '@/modules/Settlements/components/Details/shared/Header/ActionsButtons/IssueSettlementAction';
import PrintSettlementAction from '@/modules/Settlements/components/Details/shared/Header/ActionsButtons/PrintSettlementAction';
import XLSXSettlementAction from '@/modules/Settlements/components/Details/shared/Header/ActionsButtons/XLSXSettlementAction';
// import XLSXSettlementAction from '@/modules/Settlements/components/Details/Header/ActionsButtons/XLSXSettlementAction';
import { ISettlements } from '@/modules/Settlements/types';
import { Button } from '@/shared/components/atoms';
import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import DotedMenu from '@/shared/components/molecules/DotedMenu';
import { SETTLEMENT_STATUS } from '@/shared/constant/backendStatus';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import DollarUpperArrow from '~/images/shared/DollarUpperArrow.svg';
import DotsMenu from '~/images/shared/DotsMenu.svg';

interface Props {
  status?: ISettlements.ISettlementsStatus;
}
const ActionsButtons: FC<Props> = ({ status }) => {
  const { openModal } = useModal();
  const { t } = useTranslation('common');

  const statusLabel = (status && SETTLEMENT_STATUS[status]?.label) || '-';

  const handleIssueClick = useCallback(() => {
    openModal(<IssueSettlementModal />, {
      containerClassName: 'max-w-md',
      dismissable: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleDeleteSettlement = useCallback(() => {
    openModal(<DeleteSettlementAction />, {
      containerClassName: 'max-w-md',
      dismissable: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const dotedMenuList = [
    {
      title: <div className='whitespace-nowrap'>{t('delete-settlement')}</div>,
      id: 'delete-settlement',
      action: handleDeleteSettlement,
    },
  ];

  if (statusLabel === 'under_issuance')
    return (
      <div className='flex items-center gap-20'>
        <Button
          size='none'
          onClick={handleIssueClick}
          className='flex items-center justify-around gap-2 !rounded-xl px-16 py-2'
        >
          <>
            <BaseIcon size='sm'>
              <DollarUpperArrow />
            </BaseIcon>
            <span>{t('issue-settlement')}</span>
          </>
        </Button>
        <DotedMenu
          list={dotedMenuList}
          getTitle={(item) => item.title}
          getId={(item) => item?.id}
          getAction={(item) => item.action}
          // eslint-disable-next-line no-console
          onOpen={() => console.log('opened')}
          DotsMenuIcon={<DotsMenu className='rotate-90  text-24' />}
        />
      </div>
    );

  return (
    <div className='flex items-center gap-16'>
      <XLSXSettlementAction />
      {/* print */}
      <PrintSettlementAction />
    </div>
  );
};
export default ActionsButtons;
